<template>
  <div
    class="pt-14 pb-14 bulk-section mb-10"
    :class="$store.state.plan && $store.state.plan.type !== 'pro-yearly' &&
      $store.state.plan.group !== 'white-label' ? 'mt-10' : ''"
    id="bulk-pricing"
  >
    <ContactUsBulkModal
      :is-open-modal="isOpenModal"
      :total-billing-have-discount="totalBillingHaveDiscount"
      :quantity="quantity"
      :plan="plan"
      :fullSymbolCurrency="fullSymbolCurrency"
      :open-modal="isOpenModal"
      :total-billing="totalBilling"
      :discount-rate="discountRate"
      :plans="BulkLicensePlans"
      :formData="formData"
      @hide="isOpenModal = false"
      @showThanksModal="showThanksModal"
    />
    <ThanksYourRequestModal
      @closeThanksModal="isThanksRequestModal= false"
      :is-thanks-request-modal="isThanksRequestModal"
    />
    <div class="mb-9 flex justify-center items-center flex-wrap">
      <h2 class="font-bold text-2xl text-center bulk-title ">
        {{ $i18nPresenter.t('Team Up and Save More') }}
      </h2>
      <div class="header-offer-badge mt-2 xs:mt-0">
        {{ $i18nPresenter.t('Offer Expires Soon!') }}
      </div>
    </div>

    <div class="text-center font-18 ">
      <div class="wrapper-bulk ">
        <span>
          {{ $i18nPresenter.t('If you buy') }}
        </span>
        <aha-input
          class="font-14"
          @focus="trackingFocus('quantity')"
          @blur="resetError"
          placeholder="3"
          v-model="quantity"
          type="number"
          :min="2"
          :max="200"
          @input="updateWhenChangeQuantity"
          :error="errorLimitQuantity"
        />
        <span class="wrapper-text-licences">
          {{ $i18nPresenter.t('licences of') }}
        </span>
        <div class="select-box flex items-center ">
          <span @click="trackingClickSelectBox">
            <aha-select
              :value="plan"
              @change="onChangeBulkLicensePlan"
            >
              <aha-select-option :value="''">
                {{ $i18nPresenter.t('Select plan') }}...
              </aha-select-option>
              <aha-select-option
                v-for="(value, key) in BulkLicensePlans"
                :key="key"
                :value="key"
                @click="trackingClickSelectBox()"
              >
                {{ value }}
              </aha-select-option>
            </aha-select>
          </span>
          <span class="ml-2">
            {{ $i18nPresenter.t('plan, ') }}
          </span>
        </div>
        <div class="wrapper-text-pricing">
          <div class="grid items-center wrapper-text " v-if="canShowAnnualPriceText">
            <span class="text-bill-annual">{{ $i18nPresenter.t('your annual bill will be') }}</span>
            <span class="bulk-license-total-value" :class="{'currency-grid-area': totalBillingHaveDiscount === 0}">
              <span class="font-bold ml-1" v-if="totalBillingHaveDiscount > 0">
                {{ symbolCurrency }}{{ Math.round(totalBillingHaveDiscount * 100) / 100 | formatNumber }}
              </span>
            </span>

            <span class="pricing-label-discount ml-1" v-if="discountRate !==0 ">
              <p>{{ $i18nPresenter.t('Save') }} {{ Math.round(discountRate * 100) }}%</p>
            </span>
            <del class="ml-1 total-billing" v-if="discountRate !== 0">
              {{ symbolCurrency }}{{ Math.round(totalBilling * 100) / 100 | formatNumber }}
            </del>
          </div>

          <div class="flex items-center contact-us-text " v-else-if="isSelectWhiteLabelAndEnterprise">
            {{ $i18nPresenter.t('please contact us for pricing.') }}
          </div>
          <div class="grid items-center wrapper-text" v-if="plan.length === 0">
            <span class="text-bill-annual">{{ $i18nPresenter.t('your annual bill will be') }}</span>
            <span class="font-bold ml-1 empty-text">
              {{ symbolCurrency }}---
            </span>
          </div>
        </div>
      </div>
      <div
        class="flex gap-3 justify-center mt-8 flex-col sm:flex-row sm:pl-0 sm:pr-0 pr-3 pl-3 mb-4"
        v-if="plan && quantity > 1"
      >
        <aha-button
          :variant=" (!isEligibleToBuyMultipleLicenses) ? 'primary': 'base'"
          class="min-w-48"
          :class="{'secondary-button': isEligibleToBuyMultipleLicenses }"
          v-if="isShowContactButton"
          @click="openModal"
        >
          {{ $i18nPresenter.t('Contact us') }}
        </aha-button>
        <aha-button
          class="min-w-48"
          v-if="isEligibleToBuyMultipleLicenses"
          @click="createCheckout()"
          :disabled="isLoading"
        >
          {{ $i18nPresenter.t('Buy now') }}
          <aha-spinner class="ml-1" v-if="isLoading" variant="white" />
        </aha-button>
      </div>
      <div class="error">
        <p class="text-red-50 text-sm">
          {{ createCheckoutSessionError }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import Util from '@/util'
import ContactUsBulkModal from '@/components-v2/my-plan/user-pricing-v2/ContactUsBulkModal.vue'
import ThanksYourRequestModal from '@/components-v2/my-plan/user-pricing-v2/ThanksYourRequestModal.vue'
import constants from '@/constant'
import PaymentLocalizationMixin from '@/components-v2/my-plan/user-pricing-v2/PaymentLocalizationMixin'

export default {
  components: {
    ThanksYourRequestModal,
    ContactUsBulkModal,
  },
  mixins: [PaymentLocalizationMixin],
  data() {
    return {
      isThanksRequestModal: false,
      formData: {
        email: '',
        planName: '',
        message: '',
      },
      plan: '', // 'essential-yearly', 'plus-yearly', 'pro-yearly,
      isOpenModal: false,
      quantity: 3,
      BulkLicensePlans: constants.BulkLicensePlans,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      currentAccount: (state) => state.currentAccount,
      createCheckoutSessionError: (state) => state.createCheckoutSessionError,
      isCreatingCheckoutSession: (state) => state.isCreatingCheckoutSession,
      isCreatingCustomerPortal: (state) => state.isCreatingCustomerPortal,
    }),
    discountRate() {
      if (!this.plan || !this.quantity) {
        return 0
      }

      if (this.plan === 'essential-yearly' || this.plan === 'plus-yearly') {
        if (this.quantity >= 2 && this.quantity <= 4) {
          return 0.25
        }
        if (this.quantity >= 5) {
          return 0.3
        }
        return 0
      }

      if (this.plan === 'pro-yearly') {
        if (this.quantity >= 2 && this.quantity <= 4) {
          return 0.3
        }
        if (this.quantity >= 5) {
          return 0.4
        }
      }

      if (this.plan === 'ultimate-daily') {
        return 0.08
      }
      return 0
    },
    errorLimitQuantity() {
      if (!this.quantity) {
        return false
      }
      return this.quantity < 2 || this.quantity > 200
    },

    isSelectWhiteLabelAndEnterprise() {
      return this.plan === 'enterprise' || this.plan === 'whitelabel'
    },

    hasNoTeam() {
      return this.currentUser.accountId == null
    },

    hasPaidTeamPlan() {
      return this.currentAccount.plan !== null && this.currentAccount.plan !== 'free'
    },

    isFreeTeam() {
      return this.currentAccount.plan == 'free' || this.currentAccount.plan == null
    },

    isEligibleToBuyMultipleLicenses() {
      return this.totalBilling > 0 &&
          !this.isSelectWhiteLabelAndEnterprise &&
          this.quantity > 1 &&
          this.plan
    },
    canShowAnnualPriceText() {
      return this.totalBilling > 0 &&
          !this.isSelectWhiteLabelAndEnterprise &&
          this.quantity > 1 &&
          this.plan
    },

    isPersonPlan() {
      return this.hasNoTeam &&
          this.plan.length > 0 &&
          this.currentUser.plan !== 'free'
    },
    isShowContactButton() {
      if (!this.isEligibleToBuyMultipleLicenses) {
        return true
      }

      if (this.quantity > 15 && this.quantity <= 200) {
        return true
      }

      if (this.quantity < 2 || this.quantity > 200) {
        return false
      }
      if (this.totalBilling === 0) {
        return false
      }

      return false
    },

    totalBillingHaveDiscount() {
      const total = this.computeTheTotalValue(this.plan, this.quantity)
      return total * (1 - this.discountRate)
    },

    totalBilling() {
      const total = this.computeTheTotalValue(this.plan, this.quantity)
      if (total === 0) {
        return 0
      }
      return total
    },
    isLoading() {
      if (this.currentUser.plan === 'free') {
        return this.isCreatingCheckoutSession
      }
      return this.isCreatingCustomerPortal
    },

  },

  mounted() {
    this.addTestDailyPlanForBulkLicense()
  },

  methods: {
    ...mapActions(['createCheckoutSessionAction', 'hookBulkPricingAction', 'createCustomerPortalUpgradeFlowAction']),
    showThanksModal() {
      this.isThanksRequestModal = true
      this.isOpenModal = false
      this.formData.message = ''
    },
    async createCheckout() {
      if (this.quantity < 2) {
        this.$store.commit('createCheckoutSessionErrorMutation', 'Quantity must be greater than 1')
        return
      }

      if (this.quantity > 200) {
        this.$store.commit('createCheckoutSessionErrorMutation', 'Quantity must not exceed 200')
        return
      }

      const payload = {
        plan: this.plan,
        quantity: this.quantity,
        cancelUrl: window.location.origin + window.location.pathname,
      }
      Util.mixpanelTracking('My Plan', 'BLP > Buy now', this.plan, {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      })
      if (this.currentUser.plan === 'free') {
        await this.createCheckoutSessionAction(payload)
      } else {
        await this.createCustomerPortalUpgradeFlowAction(payload)
      }
    },
    onChangeBulkLicensePlan(plan) {
      this.plan = plan
      this.trackingSelectBox()
    },
    trackingSelectBox() {
      if (this.plan.length > 0 && this.quantity > 1) {
        Util.mixpanelTracking('My Plan', 'BLP > Calculated', this.plan, null, {
          quantity: this.quantity,
          amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
        })
      }
      Util.mixpanelTracking('My Plan', 'BLP > Pick a plan from the list', this.plan)
    },
    trackingClickSelectBox() {
      Util.mixpanelTracking('My Plan', 'BLP > Select plan > Open drop-down menu')
    },
    trackingFocus(type) {
      const eventCustoms = {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      }
      if (type === 'email') {
        Util.mixpanelTracking('My Plan',
          'BLP > Request a quote > Email > Focus input', this.plan, null,
          eventCustoms)
        return
      }
      if (type === 'requirement') {
        Util.mixpanelTracking('My Plan',
          'BLP > Request a quote > Message > Focus input', null,
          this.plan,
          eventCustoms)
        return
      }
      if (type === 'quantity') {
        Util.mixpanelTracking('My Plan',
          'BLP > Quantity > Focus input', null,
          this.plan,
          eventCustoms)
      }
    },
    updateWhenChangeQuantity() {
      if (this.quantity > 200) {
        this.quantity = 200
      }
    },

    closeModalThanksRequest() {
      this.isThanksRequestModal = false
    },
    closeRequestModal() {
      this.isOpenModal = false
      this.formData.message = ''
      Util.mixpanelTracking('My Plan', 'BLP > Request a quote > Close pop-up', this.plan, null, {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      })
    },
    openModal() {
      this.formData.email = this.currentUser.email
      this.isOpenModal = true
      Util.mixpanelTracking('My Plan', 'BLP > Contact us', this.plan, null, {
        quantity: this.quantity,
        amount: Math.round(this.totalBillingHaveDiscount * 100) / 100,
      })
    },

    computeTheTotalValue(plan, quantity) {
      if (plan === '' || this.isSelectWhiteLabelAndEnterprise) {
        return 0
      }

      if (!quantity) {
        return 0
      }
      if (!this.fullSymbolCurrency) {
        return 0
      }

      return constants.pricesMap[this.fullSymbolCurrency.toLowerCase()][plan] * quantity
    },

    addTestDailyPlanForBulkLicense() {
      if (sessionStorage.getItem('test-bulk-license-daily') == 'true') {
        this.BulkLicensePlans['ultimate-daily'] = 'Ultimate Daily'
      }
    },

    resetError() {
      this.$store.commit('createCheckoutSessionErrorMutation', '')
    },

  },
}
</script>
<style lang="scss" scoped>
.bullet-title {
  color: rgba(0, 0, 0, 0.75);
}

.font-16 {
  font-size: 16px;
}

.font-20 {
  font-size: 20px;
}

.font-24 {
  font-size: 24px;
}

.font-18 {
  font-size: 18px;
}

.bulk-section {
  border-radius: 8px;
  border: 1px solid var(--secondary-15, #EFF1F7);
  background: var(--primary-20, #F9FBFF);
  scroll-padding-top: 50px;
  margin-bottom: 3rem;
}

.bulk-license-total-value {
  //grid-area: 2/span 3;
}

.wrapper-info-plan {
  border-radius: 4px;
  border: 1px solid #D3D7E1;
  padding: 16px;
}

.total-billing {
  color: var(--base-70, #999);
}

.bullet-title {
  color: var(--secondary-100, #282E3E);
  font-size: 28px;
  font-weight: 600;
  text-align: center;
  line-height: 36px;
}

.text-bill-annual {
  //grid-area: 1/ span 1;
}

.pricing-label-discount {
  color: var(--green-100, #15A962);
  border-radius: 4px;
  background: var(--green-10, #EBF9F1);
  font-style: normal;
  font-weight: 700;
  padding: 4px 8px;

}

.small-label {
  padding: 2px 4px;
  font-weight: lighter;
}

.text-area {
  textarea {
    height: 7rem !important;
  }
}

.error-text {
  color: #c20a0a;
  text-align: center;
  font-size: 0.9rem;

}

.wrapper-text {
  grid-template-columns: auto auto auto auto;
  @media (max-width: 1024px) {
    grid-template-columns: auto;
    .text-bill-annual {
      grid-area: 1/ span 3;
      margin-top: 16px;
      margin-bottom: 6px;
    }

    .currency-grid-area {
      grid-area: 2/ span 3;
      justify-self: center;
    }
    .empty-text {
      grid-area: 2/span 3;
    }
  }
}

.wrapper-bulk {
  display: inline-grid;
  grid-template-columns: auto 67px auto auto auto;
  grid-template-rows: auto;
  grid-column-gap: 10px;
  grid-row-gap: 8px;
  align-items: center;
  font-size: 16px;

  .aha-select {
    height: 40px;
    font-size: 16px;
  }

  @media (max-width: 1024px) {
    grid-template-columns: auto 78px auto auto;
    grid-column-gap: 12px;
    .wrapper-text-pricing {
      grid-area: 3/ span 4;
      justify-self: center;
    }
    .contact-us-text {
      @apply mt-4;
    }
  }
  @media (max-width: 768px) {
    grid-template-columns: auto 78px auto;
    grid-template-rows: auto;
    grid-column-gap: 12px;
    grid-row-gap: 8px;
    .select-box {
      grid-area: 2/ span 3;
      justify-self: center;
      margin-top: 16px;
    }
    .wrapper-text-pricing {
      grid-area: 3/ span 3;
      justify-self: center;
    }
  }

  input {
    font-size: 14px;
  }
}

.modal-close {
  position: absolute;
  top: 12px;
  right: 12px;

  svg {
    cursor: pointer;

    path {
      fill: #999999;
    }
  }
}

.info-switch-plan {
  color: var(--base-90, #313131);
  font-size: 14px;
  font-weight: 400;
  margin-top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  .fas {
    color: #348EF6;
    margin-right: 4px;
  }
}

.secondary-button {
  background: #EFF1F7;
}

.bulk-title {
  color: rgba(40, 46, 62, 1);
}

// for ipad air
@media (max-width: 1024px) {
  //.wrapper-text-licences{
  //
  //  grid-area: 2/ span 1;
  //}
  //.select-box{
  //  flex-direction: column;
  //  align-items: flex-start;
  //}
  //.wrapper-bulk{
  //  grid-template-columns: auto 67px auto 150px auto;
  //}
}

.header-offer-badge {
  display: inline-block;
  width: 138px;
  height: 26px;
  margin-left: 12px;

  font-size: 0.8rem;
  font-weight: bold;
  color: #fff;
  border-radius: 36px;
  padding: 3px 10px;
  background-color: #33C173;
}

</style>
